<template>
    <el-dialog
            :modal="false"
            class="selfModal"
            title="字典项"
            :close-on-click-modal="false"
            :visible="itemData.state"
            width="75%"
            @close="closeModal()">
        <div style="width: 100%;height: 100%">
            <div class="M_search">
                <el-button type="success" @click="handleAdd" icon="el-icon-plus">新 增</el-button>

                <el-button
                        :disabled="deleteState"
                        type="danger"
                        icon="el-icon-delete"
                        class="handle-del mr10"
                        @click="delAllSelection"
                >删除
                </el-button>
            </div>
            <div class="tableHeight2">
                <el-table :data="tableData" v-loading="tableLoading" stripe border
                          height="400px" style="min-width: 100%;"
                          @selection-change="handleSelectionChange">
                    <el-table-column
                            type="selection"
                            width="55"
                            :selectable="checkSelectable"
                            align="center">
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="65" align="center"></el-table-column>
                    <el-table-column prop="value" label="数据值" min-width="90" align="center"></el-table-column>
                    <el-table-column prop="label" label="标签名" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="type" label="类型" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="description" label="描述" show-overflow-tooltip
                                     align="center"></el-table-column>
                    <el-table-column prop="remarks" label="备注" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip
                                     align="center"></el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                            <!--                            <el-button style="color: red" type="text" size="mini" @click="handleDel(scope.row)">删除-->
                            <!--                            </el-button>-->
<!--                            <el-button style="color: rgba(255,0,0,0.58)" disabled type="text" v-if="scope.row.system==1"-->
<!--                                       @click="handleDel(scope.row)">删除-->
<!--                            </el-button>-->
<!--                            <el-button style="color: red" type="text" v-else @click="handleDel(scope.row)">删除-->
<!--                            </el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 新增-->
        <el-dialog
                title="新增"
                :close-on-click-modal="false"
                :visible="dialogVisibleAdd"
                class="selfModal centreModal_42"
                width="480px"
                :modal="false"
                :before-close="handleCloseAdd">
            <div style="padding-right: 35px">
                <el-form :model="formValidate" :rules="ruleValidate" ref="ruleForm" label-width="100px"
                         class="demo-ruleForm">
                    <el-form-item label="类型" prop="type">
                        <el-input disabled="" v-model="formValidate.type"></el-input>
                    </el-form-item>
                    <el-form-item label="数据值" prop="value">
                        <el-input v-model="formValidate.value"></el-input>
                    </el-form-item>
                    <el-form-item label="标签名" prop="label">
                        <el-input v-model="formValidate.label"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="description">
                        <el-input v-model="formValidate.description"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input-number :min="0"  :max="99999" v-model="formValidate.sort"
                                         controls-position="right"></el-input-number>
                    </el-form-item>
                    <el-form-item label="备注" prop="remarks">
                        <el-input v-model="formValidate.remarks"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('ruleForm')" :disabled="subDisabled">确 认</el-button>
               <el-button @click="resetForm('ruleForm')">重 置</el-button>

            </span>
        </el-dialog>
        <!-- 编辑-->
        <el-dialog
                title="编辑"
                :close-on-click-modal="false"
                :visible="dialogVisibleEdit"
                :modal="false"
                class="selfModal centreModal_42"
                width="480px"
                :before-close="handleCloseEdit">
            <div style="padding-right: 35px">
                <el-form :model="EditFormValidate" :rules="EditRuleValidate" ref="ruleFormEdit" label-width="80px"
                         class="demo-ruleForm">
                    <el-form-item label="类型" prop="type">
                        <el-input disabled="" v-model="EditFormValidate.type"></el-input>
                    </el-form-item>
                    <el-form-item label="数据值" prop="value">
                        <el-input v-model="EditFormValidate.value"></el-input>
                    </el-form-item>
                    <el-form-item label="标签名" prop="label">
                        <el-input v-model="EditFormValidate.label"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="description">
                        <el-input v-model="EditFormValidate.description"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input-number :min="0"  :max="99999"
                                         v-model="EditFormValidate.sort"
                                         controls-position="right"></el-input-number>
                    </el-form-item>
                    <el-form-item label="备注"  prop="remarks">
                        <el-input v-model="EditFormValidate.remarks"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
               <el-button type="primary" @click="submitFormEdit('ruleFormEdit')" :disabled="subDisabled">确 认</el-button>
               <el-button @click="resetFormEdit('ruleFormEdit')">重 置</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {fetchItemLists, addObjItem, delObjItem,delObjItems, putObjItem} from '@/api/admin/dict'

    export default {
        name: "",
        props: {
            itemData: {
                type: Object,
                required: true
            }
        },
        data() {
            var validateSort = (rule, value, callback) => {
                if (typeof value != "number") {
                    return callback(new Error("请输入数字"));
                }
                callback();
            };
            return {
                deleteState: true,
                multipleSelection: [],
                delList: [],
                EditForm: null,
                ruleValidate: {
                    sort: [
                        {required: false, message: '该项必须填写', trigger: 'blur'},
                        {pattern: /^[0-9]\d{0,5}$/, message: '只能输入整数： 1～99999'},
                    ],
                    label: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    value: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    remarks: [
                        {required: false, message: '', trigger: 'blur'},
                        {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
                    ]
                }, // 表单验证
                formValidate: {
                    id: null,
                    dictId: '',
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                }, // 表单数据绑定
                EditRuleValidate: {
                    sort: [
                        {required: false, message: '该项必须填写', trigger: 'blur'},
                        {pattern: /^[0-9]\d{0,5}$/, message: '只能输入整数： 1～99999'},
                    ],
                    label: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    value: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    remarks: [
                        {required: false, message: '', trigger: 'blur'},
                        {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
                    ]
                }, // 表单验证
                remarks: null,
                EditFormValidate: {
                    id: null,
                    dictId: '',
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                }, // 表单数据绑定
                dialogVisibleAdd: false,
                dialogVisibleEdit: false,
                page: {
                    total: 0, // 总页数
                    currentPage: 1, // 当前页数
                    pageSize: 50 // 每页显示多少条
                },
                tableData: [],
                tableLoading: false,
                subDisabled: false,
            }
        },
        components: {},
        methods: {
            delAllSelection() {
                this.$confirm(
                    "点击“确定”按钮删除选中内容，否则请点击“取消”按钮！",
                    "信息消息",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "关闭",
                        type: "warning"
                    }
                ).then(() => {
                    this.delList = this.delList.concat(this.multipleSelection);
                    const idArr = this.multipleSelection.map(item => {
                        return item.id;
                    });
                    delObjItems(idArr).then(res => {
                        if (res.data.code == 0) {
                            if (this.tableData.length === idArr.length && this.page.currentPage > 1) {
                                this.page.total -= 1;
                                this.page.currentPage -= 1;
                            }
                            this.$message.success(`删除成功`);
                            this.multipleSelection = [];
                            this.getItemList();
                        }
                    });
                })
            },
            // 设置表格行不可选
            checkSelectable(row, index) {
                if (row.system == 1) {
                    return false;
                }
                return true;
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (this.multipleSelection.length > 0) {
                    this.deleteState = false
                } else {
                    this.deleteState = true
                }
            },
            /**
             * @description: 删除
             * @param:{}
             * @return:
             */
            handleDel: function (row) {
                this.$confirm('"是否确认删除标签名为"' + row.label + '"的数据项?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delObjItem(row.id).then(res => {
                        if (res.data.code == 0) {
                            this.getItemList()
                        } else {
                            this.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                        }
                    })
                }).catch(function () {
                })
            },
            //新增的提交及清空
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.subDisabled = true;
                        addObjItem(this.formValidate).then(res => {
                            if (res.data.code == 0) {
                                this.$refs[formName].resetFields();
                                this.subDisabled = false;
                                this.handleCloseAdd();
                                this.getItemList()
                            } else {
                                this.subDisabled = false;
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //清空新增
            resetForm(formName) {
                this.$refs[formName].resetFields();
                setTimeout(() => {
                    this.formValidate.dictId = this.itemData.data.id;
                    this.formValidate.type = this.itemData.data.type;
                    this.formValidate.remarks = ''
                }, 200)
            },
            //编辑的新增及清空
            submitFormEdit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.subDisabled = true;
                        putObjItem(this.EditFormValidate).then(res => {
                            if (res.data.code == 0) {
                                this.subDisabled = false;
                                this.handleCloseEdit()
                            } else {
                                this.subDisabled = false;
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //清空新增
            resetFormEdit(formName) {
                this.EditFormValidate.remarks = this.EditForm.remarks;
                this.EditFormValidate.id = this.EditForm.id;
                this.EditFormValidate.dictId = this.EditForm.dictId;
                this.EditFormValidate.value = this.EditForm.value;
                this.EditFormValidate.type = this.EditForm.type;
                this.EditFormValidate.label = this.EditForm.label;
                this.EditFormValidate.description = this.EditForm.description;
                this.EditFormValidate.description = this.EditForm.description;
                this.EditFormValidate.sort = this.EditForm.sort;
                this.EditFormValidate.sysFlag = this.EditForm.sysFlag;
            },
            handleCloseAdd() {
                this.$refs['ruleForm'].resetFields();
                setTimeout(() => {
                    this.formValidate.remarks = ''
                }, 200);
                this.dialogVisibleAdd = false;
            },
            handleCloseEdit() {
                this.dialogVisibleEdit = false;
                this.EditForm = null;
                this.getItemList()
            },
            closeModal() {
                this.$emit("closeItem", {state: false});
                this.itemData.state = false;
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd: function () {
                this.dialogVisibleAdd = true
            },
            handleEdit(row) {
                this.EditForm = row;
                this.dialogVisibleEdit = true;
                this.remarks = this.EditForm.remarks;
                this.EditFormValidate.remarks = this.EditForm.remarks;
                this.EditFormValidate.id = this.EditForm.id;
                this.EditFormValidate.dictId = this.EditForm.dictId;
                this.EditFormValidate.value = this.EditForm.value;
                this.EditFormValidate.type = this.EditForm.type;
                this.EditFormValidate.label = this.EditForm.label;
                this.EditFormValidate.description = this.EditForm.description;
                this.EditFormValidate.description = this.EditForm.description;
                this.EditFormValidate.sort = this.EditForm.sort;
                this.EditFormValidate.sysFlag = this.EditForm.sysFlag;
            },
            getItemList() {
                this.tableLoading = true;
                this.formValidate.dictId = this.itemData.data.id;
                this.formValidate.type = this.itemData.data.type;
                fetchItemLists(Object.assign({
                    current: this.page.currentPage,
                    size: this.page.pageSize,
                    dictId: this.itemData.data.id
                })).then(response => {
                    this.tableData = response.data.data.records;
                    this.tableLoading = false
                })
            },
        }
    }
</script>

<style scoped>
.M_search{
   text-align: right;
}
</style>
